import API from '../api';

export default class InputService {
  constructor() {
    this.API = new API();
  }

  updateEvent = (ticketId, questionId, body) => this.API.patch(`/input/${ticketId}/${questionId}/update-event`, body);
}
